import * as amplitude from '@amplitude/analytics-browser';
export interface Analytics {
    initialize: () => void
    setUser: (id: string) => void
    trackEvent: (name: string, data?: Record<string, any>) => void
  }

export class LocalAnalytics implements Analytics {
    constructor() {
      console.log("Initialize local analytics")
    }

    initialize() {
      console.log("Local analytics initialized")
    }

    setUser(id: string) {
      console.log("Set user for analytics: ", id)
    }

    trackEvent(name: string, data?: Record<string, any>) {
      console.log("Track event: ", name, data)
    }
  }
  export class AmplitudeAnalytics implements Analytics {
    apiKey: string
    isInitialized: boolean = false

    constructor(apiKey: string) {
      this.apiKey = apiKey
    }

    initialize() {
      if (!this.isInitialized) {
        amplitude.init(this.apiKey, {autocapture: {pageViews: true, sessions: true, elementInteractions: true}})
        this.isInitialized = true
      }
    }

    setUser(id: string) {
      this.initialize()
      amplitude.setUserId(id)
    }

    trackEvent(name: string, data?: Record<string, any>) {
      this.initialize()
      amplitude.track(name, data)
    }
  }

  export const analytics = process.env.AMPLITUDE_API_KEY
    ? new AmplitudeAnalytics(process.env.AMPLITUDE_API_KEY)
    : new LocalAnalytics()